import {
 
  TODOS_REQUEST,
  TODOS_SUCCESS,
  TODOS_FAIL,
  TODOS_RESET,

  ADD_TODO_REQUEST,
  ADD_TODO_SUCCESS,
  ADD_TODO_FAIL,
  ADD_TODO_RESET,

  EDIT_TODO_REQUEST,
  EDIT_TODO_SUCCESS,
  EDIT_TODO_FAIL,
  EDIT_TODO_RESET,



} from "../constants/dataConstants";

export const todosReducer = (
  state = { loading: false, data:   []  },
  action
) => {
  switch (action.type) {
    case TODOS_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case TODOS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case TODOS_FAIL:
      return {
        data:  [],
        loading: false,
        error: action.payload,
        status:"error"
      };
    case TODOS_RESET:
      return { loading: false, data:  [], status:"reset"  };

    default:
      return state;
  }
};


export const addTodoReducer = (
  state = { loading: false, data:   []  },
  action
) => {
  switch (action.type) {
    case ADD_TODO_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case ADD_TODO_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case ADD_TODO_FAIL:
      return {
        data:  [],
        loading: false,
        error: action.payload,
        status:"error"
      };
    case ADD_TODO_RESET:
      return { loading: false, data:  [], status:"reset"  };

    default:
      return state;
  }
};



export const editTodoReducer = (
  state = { loading: false, data:   []  },
  action
) => {
  switch (action.type) {
    case EDIT_TODO_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case EDIT_TODO_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case EDIT_TODO_FAIL:
      return {
        data:  [],
        loading: false,
        error: action.payload,
        status:"error"
      };
    case EDIT_TODO_RESET:
      return { loading: false, data:  [], status:"reset"  };

    default:
      return state;
  }
};
